import { useLingui } from "@lingui/react";
import { t } from "@lingui/macro";

import { NextPageWithLayout } from "src/components/layout/types";
import { getLayout } from "src/components/layout/SetupPageLayout";
import SetupPages from "src/components/routes/Setup/common/constants/SetupPages";
import PageContainer from "src/components/routes/Setup/common/components/PageContainer";
import BankDetails from "src/components/routes/Setup/bank-details";
import IllustrationGlobe from "src/assets/png/value-prop/illustration-globe@2x.png";
import { usePrimaryCreditor } from "src/libraries/creditor/hooks";

const BankDetailsPage: NextPageWithLayout = () => {
  const { i18n } = useLingui();
  const creditor = usePrimaryCreditor();
  const internationalPaymentsEnabled = Boolean(creditor?.fx_payout_currency);
  const australianMerchant = creditor?.geo === "AU";

  const internationalPaymentsProps = {
    imagePath: IllustrationGlobe,
    headerText: i18n._(
      t({
        id: "setup.bank-details.valueProp.headerText",
        message: "Go global",
      })
    ),
    content: i18n._(
      t({
        id: "setup.bank-details.valueProp.content",
        message:
          "Collect payments from 30+ countries into your home bank account, with in-built FX at the real market rate.",
      })
    ),
  };

  return (
    <>
      <PageContainer
        {...(internationalPaymentsEnabled && !australianMerchant
          ? internationalPaymentsProps
          : {})}
      >
        <BankDetails />
      </PageContainer>
    </>
  );
};

BankDetailsPage.getLayout = getLayout(SetupPages.BankDetails);

export default BankDetailsPage;
